import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class SeatSwapRequestRowHistory extends BaseAPIModel {
    fields() {
        return {};
    }

    // WARNING: this will only work for a single attendee
    static listUrl({ organizationId, eventId, attendeeId }) {
        if (!organizationId || !eventId || !attendeeId) {
            throw new ArgumentError(`[Model][Seat Swap History][getAll] organizationId, eventId and attendeeId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/seat_swap_rows/${attendeeId}`;
    }
}
